import { Context as AuthorizationContext } from 'authorization/Context';
import AuthorizationError from 'authorization/Error';
import { checkRoutePermission } from 'common/utils';
import React, { useContext } from 'react';

interface AuthorizationRouteProps {
  path?: string;
  permission: string | undefined;
  element?: React.ReactElement;
  children?: React.ReactNode;
}

const AuthorizationRoute: React.FC<AuthorizationRouteProps> = ({
  path,
  permission,
  element,
  children,
}) => {
  const { isAuthorized } = useContext(AuthorizationContext);

  if (permission && !checkRoutePermission(permission, isAuthorized)) {
    return <AuthorizationError />;
  }

  if (element) {
    return element;
  }

  if (children) {
    return <>{children}</>;
  }

  return null;
};

export default AuthorizationRoute;
